import React from 'react'
import ReactApexChart from 'react-apexcharts';

function PiChart({ 
  series = [20, 40, 30, 10], 
  title = 'Your Title', 
  labels = ['Lable A','Lable B','Lable C','Lable D'] 
}) {
  const state = {
    series,
    options: {
      title: { text: title, align: "center" },
      chart: {
        type: 'pie',
        toolbar: { show: false }
      },
      colors: ['#028FD7', '#015681', '#001D2B', '#4EB1E3'],
      labels,
      legend: {
        position: "bottom",
        fontSize: "14px",
      },
      responsive: [
        {
          breakpoint: 768, // tablets & below
          options: {
            chart: {
              width: "50%",
            },
            legend: {
              position: "bottom"
            }
          }
        },
        {
          breakpoint: 480, // mobile
          options: {
            chart: {
              width: "100%",
            },
            legend: {
              position: "bottom",
              fontSize: "12px"
            }
          }
        }
      ]
    }
  };

  return (
    <div 
      style={{
        border: '1px solid #ccc',
        borderRadius: '10px',
        margin: '15px',
        padding: '10px',
        width: '100%',
        maxWidth: '400px', // prevents stretching too wide
      }}
    >
      <ReactApexChart 
        options={state.options} 
        series={state.series}
        type="pie" 
        width="100%" // let Apex resize with container
      />
    </div>
  )
}

export default PiChart
